import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Tooltip } from '@material-ui/core'
import md5 from 'md5';
import _ from 'lodash';

function nameToAvatarText(name) {
  const chunks = name.split(' ');
  const firstLetters = chunks.reduce((acc, chunk) => {
    if (!_.isEmpty(chunk)) {
      return acc + chunk.charAt(0);
    }
    return acc;
  }, "");
  return firstLetters.toUpperCase();
}

function Gravatar (props) {
  const {
    email = '',
    name = '',
    useBlank = false,
    // J-all-348: d=404 relies on the img erroring and JS swapping in a fallback. Static HTML
    // contexts (ReactDOMServer + innerHTML, like the mention dropdown) never run that fallback,
    // so they pass 'mp' to get gravatar's server-side silhouette instead of a broken image.
    defaultImage = '404',
    className,
    onClick
  } = props;

  const blankCode = useBlank ? 'blank' : defaultImage;
  const url = `https://www.gravatar.com/avatar/${md5(email, { encoding: 'binary' })}?d=${blankCode}`;
  const isAI = email === '' && name === 'AI';



  // you won't get the default image if you have a child element,
  // so we have to have two versions of the avatar render
  if (name) {
    return (
      <Tooltip key={`tip${email}`} title={(<div>{name}<br/>{email}</div>)}>
          <Avatar
            className={className}
            key={email}
            src={isAI ? '/images/ai-icon-light.svg' : url}
            onClick={onClick}
          >
            {nameToAvatarText(name)}
          </Avatar>
      </Tooltip>
    )
  }

  return (
    <Tooltip key={`tip${email}`} title={email}>
        <Avatar
          className={className}
          key={email}
          src={url}
          onClick={onClick}
        />
    </Tooltip>
  );
}

Gravatar.propTypes = {
  email: PropTypes.string,
  name: PropTypes.string,
  useBlank: PropTypes.bool,
  defaultImage: PropTypes.string,
  onClick: PropTypes.func
};

export default Gravatar;
